<template>
  <b-dropdown
    title="Filtrar"
    aria-role="list"
    class="card-drop-simple dropdown-container"
    position="is-bottom-left"
  >
    <div slot="trigger">
      <KButton
        height="34px"
        width="unset"
        font-weight="400"
        font-size="0.8125rem"
        border-radius="0.25rem"
        @click="$emit('open-filter')"
      />
    </div>
    <div v-if="filterVisibility" class="container-dropdown">
      <div class="header-container-filter">
        <b-button type="is-danger is-small" outlined @click="$emit('clear')">
          Limpar
        </b-button>
        <h1 class="header-filtros-header">
          {{ title }}
        </h1>
        <b-button type="is-primary is-small" @click="$emit('apply', false)">
          Aplicar
        </b-button>
      </div>
      <div slot="filters-container" class="container-filter-custom">
        <slot name="container" />
      </div>
    </div>
  </b-dropdown>
</template>

<script>
import KButton from '../buttons/Default';

export default {
	components: {
		KButton,
	},
	props: {
		filterVisibility: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: 'Filtros',
		},
	}
};
</script>

<style lang="scss" scoped>
.container-filter-custom {
  // margin-top: 10px;
  padding: 0 10px;
}

.filtro-icone {
  color: #3c4257;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  margin-left: 4px;
}
.filters-container {
  margin-top: 20px;
}

.card-drop-simple {
  color: #343a40;
  position: relative;
}

.header-container-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: #f3f3f387;
  border-bottom: 1px solid gainsboro;
}
.container-dropdown {
  width: 350px;
  display: flex;
  flex-direction: column;
  // background-color: white;
  // padding: 10px;
}

.header-filtros-header {
  font-size: 14px;
}
</style>
